module.exports = __webpack_public_path__ + "static/media/103.dbf81339.gif";